import { render, staticRenderFns } from "./ConfirmModalComponent.vue?vue&type=template&id=2836a539&"
import script from "./ConfirmModalComponent.vue?vue&type=script&lang=js&"
export * from "./ConfirmModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports